import { StaffListProps } from "../Staff.type";
import { useState } from "react";
import { GridColDef, GridRowSelectionModel } from "@mui/x-data-grid";
import GridView from "../../../../shared/components/GridView";
import { formatDateForInput } from "../../../../shared/utils/formatDate";

const StaffList: React.FC<StaffListProps> = ({
  staffs,
  onStaffSelect,
  rowSelectionModel,
  onRowSelectionModelChange,
}) => {
  const columns: GridColDef[] = [
    { field: "firstName", headerName: "First Name", flex: 1, width: 150 },
    { field: "lastName", headerName: "Last Name", flex: 1, width: 150 },
    {
      field: "dateOfBirth",
      headerName: "Date Of Birth",
      flex: 1,
      width: 150,
      valueFormatter: (params: any) => formatDateForInput(params as string),
    },
    { field: "phoneNumber", headerName: "Phone Number", flex: 1, width: 150 },
    { field: "email", headerName: "Email", flex: 1, width: 150 },
    { field: "address", headerName: "Address", flex: 1, width: 150 },
  ];

  return (
    <div>
      <div style={{ height: "400px", width: "100%" }}>
        <GridView
          data={staffs}
          columns={columns}
          rowSelectionModel={rowSelectionModel}
          onRowSelectionModelChange={onRowSelectionModelChange}
          onLinkClick={onStaffSelect}
          disableMultipleRowSelection={true}
          linkColumnNames={["firstName"]}
        ></GridView>
      </div>
    </div>
  );
};

export default StaffList;
